import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/root/app/craft-web/layouts/auth.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/root/app/craft-web/layouts/default.vue").then(m => m.default || m)),
  "default-old": defineAsyncComponent(() => import("/root/app/craft-web/layouts/default_old.vue").then(m => m.default || m))
}